import { finish, error } from '../../../modules/user/actions/change-address';

import api from '../../../api';

export function request(dispatch, action) {
    api.post('/user/change-address', {
        postCode: action.postCode,
        addressLine1: action.addressLine1,
        addressLine2: action.addressLine2,
        city: action.city
    }).then(
        ({ data }) => dispatch(finish(data)),
        ({ errors }) => dispatch(error(errors))
    );
}
